import styled from 'styled-components'

const Loading = styled.div`
    flex: 1;
    background-color: inherit;
    display: flex;
    justify-content: center;
    align-items: center;
`

export default Loading
